import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ChargeTypesViewModel from "../../viewModels/chargeTypes/chargeTypesViewModel";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import DotLoader from "../common/dotLoader";
import { chargeTypeIconWithShadow } from "utils/chargeTypeIcon";
import { validityDays } from "entities/chargeValidity";
import styles from "./chargeTypesView.module.scss";

export const ChargeTypesView: ViewComponent<ChargeTypesViewModel> = observer(({ vm }) => {
  const chargeTypes = vm.chargeTypes();

  return (
    <div className="row">
      {chargeTypes.map(chargeType => {
        return (
          <div
            className="col col-12 col-md text-center px-0 mb-2 d-flex flex-row flex-md-column align-items-center"
            key={chargeType.id}>
            <div className="img mr-4 mr-md-0">
              <a href={`${vm.eshopUrl}#/eshop/order?days=${validityDays(chargeType.validFor)}`} title={vm.translate("buy")}>
                <img
                  src={chargeTypeIconWithShadow(chargeType.validFor, vm.isCSLocale)}
                  alt={vm.chargeTypeDescription(chargeType.validFor)}
                  className={styles.chargeTypeIcon}
                />
              </a>
            </div>
            <div className="text-left text-md-center">
              <span className={styles.chargePrice}>
                {vm.isInitialized && chargeType._standardPrice ? (
                  vm.formatPrice(chargeType._standardPrice)
                ) : (
                  <>
                    <DotLoader /> {vm.currency}
                  </>
                )}
              </span>

              <span className="d-block mt-2">
                <Icon icon={IconType.Leaf} width={16} height={16} className="mr-2 text-success" />
                {vm.translate("ecoPrice")}
              </span>
              <span className="d-block mb-2">
                {vm.isInitialized && chargeType._ecoPriceMin && chargeType._ecoPriceMax ? (
                  vm.formatEcoPriceRange(chargeType._ecoPriceMin, chargeType._ecoPriceMax)
                ) : (
                  <>
                    <DotLoader /> {vm.currency}
                  </>
                )}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
});

registerView(ChargeTypesView, ChargeTypesViewModel);
